import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { IconButton } from '@fluentui/react';
import ContextMenu from './AppBarContextMenu';
import HealthStatuses from './HealthStatuses';
import {
  BrandLogoFull as BrandLogoFullIcon,
  BrandLogo as BrandLogoIcon,
} from '../Brand';
import BrokerIdLogo from './BrokerIdLogo';

const hamburgerIcon = { iconName: 'GlobalNavButton' };

function AppBar({ openPanel }) {
  const history = useHistory();
  return (
    <header className="ms-depth-8 app-bar">
      <IconButton
        iconProps={hamburgerIcon}
        className="toggle-button"
        onClick={openPanel}
      />
      <BrandLogoFullIcon
        className="brand-icon-full"
        onClick={() => history.push('/')}
      />
      <BrandLogoIcon className="brand-icon" onClick={() => history.push('/')} />
      <BrokerIdLogo />
      <HealthStatuses />
      <ContextMenu />
    </header>
  );
}

AppBar.propTypes = {
  openPanel: PropTypes.func.isRequired,
};

export default AppBar;
